let initialized = false

export function trackRouteChange(to, from) {
  if (!initialized || !from || !from.name) {
    return
  }

  window.dataLayer.push({
    event: 'vue_route_change',
    page_title: document.title,
    page_location: window.location.href,
    page_path: to.fullPath,
    previous_page_path: from.fullPath
  })
}

export function initAnalytics(router) {
  if (initialized || typeof window === 'undefined') {
    return
  }

  window.dataLayer = window.dataLayer || []

  router.afterEach((to, from) => {
    trackRouteChange(to, from)
  })

  initialized = true
}
